module.exports = __webpack_public_path__ + "static/media/Illupays.4f9205ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Illupays.svg
// module id = 1112
// module chunks = 0